import React from "react";
//Page Components
import AboutSection from "../components/AboutSection";
import CompetencesSection from "../components/CompetencesSection";
import FaqSection from "../components/FaqSection";
import SkillsSection from "../components/SkillsSection";
//Animations
import { motion } from "framer-motion";
import { pageAnimation } from "../animation";
import ScrollTop from "../components/ScrollTop";

const AboutMe = () => {
  return (
    <motion.div
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
    >
      <AboutSection />
      <CompetencesSection />
      <SkillsSection />
      <FaqSection />
      <ScrollTop />
    </motion.div>
  );
};

export default AboutMe;
